/* ============================================================
   NATTA Form — pretraga uzivo (vlasnik, 9. 10. 2026: „pretraga
   treba da bude live").

   Svaka forma sa [data-live-search] dobija padajuci panel ispod polja:
   proizvodi (slika, naziv, cijena) i kategorije, dok kupac kuca — bez
   Entera. Izvor je Shopifyjev /search/suggest.json (Predictive Search),
   isti indeks kao stranica pretrage.

   - od 2 znaka, sa pauzom od 180 ms; prethodni zahtjev se prekida
   - strelice gore/dolje biraju stavku, Enter je otvara, Esc zatvara
   - Enter bez izabrane stavke salje formu (cijela stranica rezultata)
   - klik van panela ga zatvara
   ============================================================ */
(function () {
  'use strict';

  var forms = document.querySelectorAll('form[data-live-search]');
  if (!forms.length || !window.fetch) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(priceStr) {
    var cents = Math.round(parseFloat(priceStr) * 100);
    if (isNaN(cents)) return '';
    if (window.NattaMoney && window.NattaMoney.format) return window.NattaMoney.format(cents);
    return 'KM ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  forms.forEach(function (form, fi) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    var panel = document.createElement('div');
    panel.className = 'n-ls';
    panel.id = 'n-ls-' + fi;
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Prijedlozi pretrage');
    form.appendChild(panel);
    form.classList.add('n-ls-host');

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');

    var timer = null;
    var ctrl = null;
    var active = -1;
    var lastQ = '';

    function items() {
      return Array.prototype.slice.call(panel.querySelectorAll('[data-ls-item]'));
    }

    function setActive(i) {
      var list = items();
      list.forEach(function (el, k) {
        el.classList.toggle('is-active', k === i);
        el.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      active = i;
      if (i >= 0 && list[i]) {
        input.setAttribute('aria-activedescendant', list[i].id);
        if (list[i].scrollIntoView) list[i].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function render(q, res) {
      var products = (res && res.products) || [];
      var cols = (res && res.collections) || [];
      var h = '';
      var n = 0;
      if (products.length) {
        h += '<p class="n-ls__h">Proizvodi</p><ul class="n-ls__list">';
        products.forEach(function (p) {
          var id = panel.id + '-o' + n++;
          h += '<li><a class="n-ls__p" id="' + id + '" role="option" data-ls-item href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(thumb(p.image)) + '" alt="" width="40" height="50" loading="lazy">' : '<span class="n-ls__ph"></span>') +
            '<span class="n-ls__t">' + esc(p.title) + '</span>' +
            '<span class="n-ls__pr">' + esc(money(p.price)) + '</span></a></li>';
        });
        h += '</ul>';
      }
      if (cols.length) {
        h += '<p class="n-ls__h">Kategorije</p><ul class="n-ls__list n-ls__list--cols">';
        cols.forEach(function (c) {
          var id = panel.id + '-o' + n++;
          h += '<li><a class="n-ls__c" id="' + id + '" role="option" data-ls-item href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        h += '</ul>';
      }
      if (!products.length && !cols.length) {
        h += '<p class="n-ls__empty">Nema rezultata za „' + esc(q) + '“. Pokušajte: steznik, bodi, grudnjak.</p>';
      } else {
        var id2 = panel.id + '-o' + n++;
        h += '<a class="n-ls__all" id="' + id2 + '" role="option" data-ls-item href="' + esc(root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">' +
          'Prikaži sve rezultate za „' + esc(q) + '“ →</a>';
      }
      panel.innerHTML = h;
      setActive(-1);
      open();
    }

    function run() {
      var q = input.value.trim();
      if (q.length < 2) { lastQ = ''; close(); return; }
      if (q === lastQ && !panel.hidden) return;
      lastQ = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product,collection' +
        '&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,tag';
      panel.classList.add('is-loading');
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          panel.classList.remove('is-loading');
          if (input.value.trim() !== q) return; // stigao zakasnjeli odgovor
          render(q, d && d.resources && d.resources.results);
        })
        .catch(function () { panel.classList.remove('is-loading'); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) open();
    });

    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'ArrowDown') {
        if (panel.hidden) { run(); return; }
        e.preventDefault();
        setActive(Math.min(active + 1, list.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(active - 1, -1));
      } else if (e.key === 'Enter') {
        if (active >= 0 && list[active]) {
          e.preventDefault();
          window.location.href = list[active].getAttribute('href');
        }
      } else if (e.key === 'Escape') {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  });
})();
